module.exports = __webpack_public_path__ + "img/hero-quiz.94248cfb.jpg";